// NGXS
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ASetUserAppLocation } from './../actions/user-app-location.action';
import { Injectable } from '@angular/core';

// Models and interfaces

export interface UserAppLocationStateI {
  userAppLocation: 'AUTH' | 'APP';
}

@State<UserAppLocationStateI>({
  name: 'UserAppLocationState',
  defaults: {
    userAppLocation: 'AUTH',
  },
})
@Injectable({
  providedIn: 'root',
})
export class UserAppLocationState {
  @Selector()
  static getUserAppLocation(
    state: UserAppLocationStateI,
  ): UserAppLocationStateI {
    return state;
  }

  @Action(ASetUserAppLocation)
  setUserAppLocation(
    { patchState }: StateContext<UserAppLocationStateI>,
    { payload }: ASetUserAppLocation,
  ): void {
    patchState({
      userAppLocation: payload,
    });
  }
}
